export { default } from './global-error-boundary';
